import Typing from './Typing';

export default Typing;
export { default as Backspace } from './Backspace';
export { default as Cursor } from './Cursor';
export { default as Delay } from './Delay';
export { default as Reset } from './Reset';
export { default as Speed } from './Speed';
